
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinkhedcity() {



    const cardData =
    {
        keyword: 'Cab Service in Khed City',
        heading: 'Platinum24 Cabs: Cab Service in Khed City',
        headingDescription: ' Platinum24 Cabs provides reliable Cab Service in Khed City, offering convenient travel options for local commutes, airport transfers, business trips, and long-distance journeys. Our fleet of hatchbacks, sedans, SUVs, and luxury cars is well-maintained to ensure safe and comfortable travel for individuals, families, and corporate clients. With professional drivers, punctual pickups, and transparent fares, we make every trip smooth and stress-free. Whether you’re traveling within Khed City or heading towards Pune, Mumbai, or other destinations, Platinum24 Cabs guarantees affordable pricing, dependable service, and complete customer satisfaction.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. It was once the seat of the Maratha Empire and still echoes the legacy of Bajirao and Mastani. Its mighty Delhi Gate, fountains, and expansive gardens attract thousands of visitors. Though destroyed by fire in 1828, the ruins still retain grandeur. The evening light-and-sound show recreates Maratha history. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a majestic monument tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum displaying Gandhi’s personal belongings and photographs. Its sprawling lawns and Italian arches add to the charm. It is also the resting place of Kasturba Gandhi. Aga Khan Palace is Pune’s historical gem of inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. The fort sits atop a hill offering trekking trails and panoramic Sahyadri views. Visitors explore its bastions, memorials, and temples reflecting Maratha valor. Monsoon adds mist, waterfalls, and greenery. Local villagers serve rustic pithla-bhakri meals. Sinhagad is Pune’s perfect mix of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The idol, adorned with gold and ornaments, attracts lakhs of devotees annually. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. It is also known for charitable and cultural activities. The spiritual aura here draws devotees and tourists alike. Dagdusheth Ganpati is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The site features a sanctum, massive stone pillars, and a Nandi mandapa. Despite being in the city’s center, it offers peace and a spiritual retreat. Evening chants enhance the mystical ambiance. Its carvings showcase early Indian rock-cut craftsmanship. Pataleshwar is Pune’s hidden heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure trove with over 20,000 artifacts collected by Dr. Dinkar Kelkar. The collection includes ornaments, sculptures, musical instruments, and antiques of daily life. The recreated Mastani Mahal is the highlight for visitors. Students and history enthusiasts find it fascinating and educational. It preserves centuries of cultural heritage. The museum is Pune’s proud showcase of art and tradition."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop houses the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the shrine, blending devotion with adventure. Smaller shrines and a museum add cultural depth. Sunrises and sunsets from here are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub of wellness and spirituality. Spread across serene gardens, it offers meditation, yoga, and personal growth workshops. Zen-inspired landscapes and modern facilities attract seekers worldwide. Visitors experience rejuvenation, peace, and mindfulness here. It is a unique blend of spirituality and modern lifestyle. Osho Ashram is Pune’s international retreat of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, modeled after Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and manicured lawns. Families and couples enjoy peaceful walks, picnics, and photography here. Seasonal flowers add charm throughout the year. The garden reflects Indo-Japanese cultural ties. Pu La Deshpande Garden is Pune’s lush green paradise."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. It supplies water to the city while offering scenic landscapes. Monsoon turns it into a picturesque spot with overflowing waters. Vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],


       "services": [
    {
      "name": "Khed City Cab Service",
      "description": "Make your daily travel easy and reliable with our Khed City Cab Service, offering fast, clean, and comfortable cab options throughout Khed City. Whether you're a resident or visitor, we ensure timely pickups, courteous drivers, and well-maintained vehicles at affordable rates. From local commutes to long-distance rides, our cabs are perfect for work, shopping, errands, and more. With 24x7 customer support and easy booking, your next ride in Khed City is just a few taps away."
    },
    {
      "name": "Taxi Service Khed City",
      "description": "Our Taxi Service Khed City is built for convenience and dependability, providing a wide range of vehicles for solo travelers, families, and corporate riders. Whether you're heading to a meeting, catching a train, or simply need to get across town, our experienced drivers and GPS-enabled taxis ensure smooth, on-time travel. Enjoy transparent fares, instant bookings, and a customer-first approach that makes every trip pleasant and stress-free."
    },
    {
      "name": "Khed City Local Taxi",
      "description": "Explore every corner of the city with our Khed City Local Taxi service. Ideal for everyday transportation like market visits, office commutes, or local appointments, our taxis offer comfort, punctuality, and affordability. All vehicles are sanitized, AC-equipped, and driven by local experts who know the fastest routes. Whether it’s a short hop or a half-day rental, we have the right vehicle ready for your needs."
    },
    {
      "name": "Affordable Taxi Khed City",
      "description": "Looking for budget-friendly rides in Khed City? Our Affordable Taxi Khed City service delivers great value without cutting corners on comfort or safety. With fixed pricing, no hidden charges, and fuel-efficient vehicles, this service is perfect for students, office-goers, and budget-conscious travelers. Choose hourly or full-day packages, and enjoy smooth travel with polite drivers and reliable service."
    },
    {
      "name": "Khed City Taxi with Driver",
      "description": "Relax and let us do the driving with our Khed City Taxi with Driver service. Our professional chauffeurs are trained, background-verified, and well-versed with the local area. Whether you're heading to a wedding, a business meeting, or just want to enjoy the ride stress-free, our driver-inclusive taxis offer the ultimate convenience. Book for a few hours or the whole day — we adjust to your schedule and needs."
    },
    {
      "name": "Khed City Airport Taxi",
      "description": "Catch your flight on time with our Khed City Airport Taxi service. Available 24/7, our airport taxis provide reliable transfers to Pune Airport and nearby terminals. With timely pickups, courteous drivers, and spacious, luggage-friendly vehicles, your airport journeys become seamless. We also track your flight to accommodate any delays, ensuring smooth and stress-free arrivals or departures."
    },
    {
      "name": "Cab Rental Khed City",
      "description": "Need a car for a few hours or a few days? Our Cab Rental Khed City service offers flexible rental options to suit every need — from short-term rentals to full-day bookings. Choose from a wide variety of vehicles including hatchbacks, sedans, and SUVs, with or without a driver. All our vehicles are sanitized, serviced, and available at competitive prices. Doorstep pickup/drop is available on request for maximum convenience."
    },
    {
      "name": "Khed City Outstation Taxi",
      "description": "Planning to travel beyond city limits? Our Khed City Outstation Taxi service offers a safe and comfortable option for intercity travel. Whether you're heading to Pune, Mumbai, or nearby hill stations, we provide round-trip and one-way services with experienced drivers and well-maintained vehicles. Transparent pricing, route flexibility, and 24x7 support ensure your long-distance travel is smooth and worry-free."
    },
    {
      "name": "Khed City Corporate Taxi",
      "description": "Optimize your business travel with our Khed City Corporate Taxi service, tailored for organizations, employees, and executives. We offer reliable, clean, and professional vehicles with trained chauffeurs to handle daily commutes, client pickups, and corporate events. Benefits include GST billing, monthly invoices, dedicated support, and custom travel plans. Count on us for punctual and professional corporate transportation solutions."
    },
    {
      "name": "Khed City Taxi Deals",
      "description": "Save more on every ride with exclusive Khed City Taxi Deals. Enjoy discounts on early bookings, repeat rides, and festive offers. Perfect for daily commuters and frequent travelers, our deals provide high-quality service at lower rates. Stay updated through our app or website to never miss out on a great deal. Whether you're booking a local or outstation taxi, we help you travel smart and save big."
    },
    {
      "name": "Khed City Family Taxi Service",
      "description": "Travel with your loved ones in comfort using our Khed City Family Taxi Service. Whether you're attending a function, going on a weekend trip, or visiting relatives, our spacious vehicles and family-friendly amenities make the ride enjoyable. Safety is our top priority — child seats and extra luggage space are available on request. Our polite drivers ensure a calm, pleasant journey for every family member."
    },
    {
      "name": "Taxi Booking Online Khed City",
      "description": "Book your taxi in seconds with our Taxi Booking Online Khed City service. Using our mobile-friendly website or app, you can choose your car, schedule pickup, and pay online — all within minutes. Our system offers instant booking confirmation, driver contact details, and real-time tracking. No more calling around — just tap, book, and ride with confidence, anytime and anywhere."
    },
    {
      "name": "Khed City Taxi Service 24x7",
      "description": "Need a ride at odd hours? Our Khed City Taxi Service 24x7 operates round the clock to ensure you’re never stranded. Whether it’s an early airport run, a medical emergency, or a late-night return, our drivers are ready to assist. With well-maintained vehicles and trained staff available day and night, we are your go-to taxi solution — anytime, anywhere in Khed City."
    }
  ],
  "tableData": [
    ["Khed City Cab Service", "Taxi Service Khed City"],
    ["Khed City Local Taxi", "Affordable Taxi Khed City"],
    ["Khed City Taxi with Driver", "Khed City Airport Taxi"],
    ["Cab Rental Khed City", "Khed City Outstation Taxi"],
    ["Khed City Corporate Taxi", "Khed City Taxi Deals"],
    ["Khed City Family Taxi Service", "Taxi Booking Online Khed City"],
    ["Khed City Taxi Service 24x7", "—"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Cab Service in Khed City",
    "WhyChoosedescription": "Platinum24 Cabs offers dependable and affordable cab services in Khed City for all your travel needs."
  },
  {
    "WhyChooseheading": "Multiple Vehicle Options to Suit Your Comfort",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and tempo travellers based on your group size and travel preferences."
  },
  {
    "WhyChooseheading": "Sanitized and Well-Maintained Vehicles",
    "WhyChoosedescription": "All cabs are regularly cleaned and sanitized to ensure a safe and hygienic ride in Khed City."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Local Knowledge",
    "WhyChoosedescription": "Our professional drivers are well-versed with Khed City routes, ensuring timely and smooth travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Fees",
    "WhyChoosedescription": "We offer clear and upfront fares that include fuel, tolls, and driver charges—no surprises."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Booking Assistance",
    "WhyChoosedescription": "Our support team is available around the clock to assist with your bookings and travel queries in Khed City."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages for Every Need",
    "WhyChoosedescription": "Choose from hourly, daily, or long-term rentals customized to suit your schedule and budget."
  },
  {
    "WhyChooseheading": "Easy Online Booking with Instant Confirmation",
    "WhyChoosedescription": "Book your Khed City cab easily via our website or app with real-time confirmation and updates."
  }
]
















    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer cab services in Khed City?',
        answer: 'Yes, Platinum24 Cabs provides reliable and efficient cab services in Khed City for all types of travel needs.',
    },
    {
        question: 'How can I book a cab in Khed City with Platinum24 Cabs?',
        answer: 'You can book a cab easily through our website, mobile app, or by calling our 24x7 customer support.',
    },
    {
        question: 'What types of vehicles are available for cab service in Khed City?',
        answer: 'We offer hatchbacks, sedans, SUVs, and luxury vehicles to suit your comfort and budget.',
    },
    {
        question: 'Can I hire a cab in Khed City for both local and outstation travel?',
        answer: 'Yes, Platinum24 Cabs provides services for local travel within Khed City as well as for outstation trips.',
    },
    {
        question: 'Are the drivers familiar with routes in Khed City?',
        answer: 'Absolutely, our drivers are well-trained, licensed, and familiar with Khed City and nearby areas.',
    },
    {
        question: 'Is hourly and daily cab service available in Khed City?',
        answer: 'Yes, we offer both hourly and full-day rental packages for maximum flexibility.',
    },
    {
        question: 'Are cabs in Khed City sanitized and safe?',
        answer: 'Yes, all our cabs are sanitized regularly, and safety protocols are strictly followed by our drivers.',
    },
    {
        question: 'Is Platinum24 Cabs available 24x7 in Khed City?',
        answer: 'Yes, our cab services in Khed City are available 24x7 for your convenience.',
    },
    {
        question: 'What payment modes are accepted for cab bookings in Khed City?',
        answer: 'We accept UPI, digital wallets, credit/debit cards, and cash payments.',
    },
    {
        question: 'Can I set my own pickup and drop-off points in Khed City?',
        answer: 'Yes, you can choose any custom pickup and drop-off location within Khed City while booking.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Mahesh Shinde',
        feedback: 'The cab service in Khed City was excellent. Clean vehicle, polite driver, and on-time pickup.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Pooja Desale',
        feedback: 'Great experience with Platinum24 Cabs in Khed City. Booking process was smooth and easy.',
        rating: 5,
    },
];








































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];










const khedCityCabServiceSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Affordable and reliable cab service in Khed City offering local taxi, airport transfers, outstation cabs, corporate taxi, and family taxi services with driver.",
  "areaServed": {
    "@type": "Place",
    "name": "Khed City, Pune"
  },
  "serviceType": [
    "Khed City Cab Service",
    "Taxi Service Khed City",
    "Khed City Local Taxi",
    "Affordable Taxi Khed City",
    "Khed City Taxi with Driver",
    "Khed City Airport Taxi",
    "Cab Rental Khed City",
    "Khed City Outstation Taxi",
    "Khed City Corporate Taxi",
    "Khed City Taxi Deals",
    "Khed City Family Taxi Service",
    "Taxi Booking Online Khed City",
    "Khed City Taxi Service 24x7"
  ],
  "telephone": "+91-XXXXXXXXXX"
};



    return (
        <div>

<Helmet>
  <title>Cab Service in Khed City | Affordable Taxi Service Khed City Pune</title>
  <meta
    name="description"
    content="Affordable and reliable cab service in Khed City offering local taxi, airport transfers, outstation cabs, corporate taxi, and family taxi services with driver."
  />
  <meta
    name="keywords"
    content="Khed City Cab Service, Taxi Service Khed City, Khed City Local Taxi, Affordable Taxi Khed City, Khed City Taxi with Driver, Khed City Airport Taxi, Cab Rental Khed City, Khed City Outstation Taxi, Khed City Corporate Taxi, Khed City Taxi Deals, Khed City Family Taxi Service, Taxi Booking Online Khed City, Khed City Taxi Service 24x7"
  />
  <script type="application/ld+json">
    {JSON.stringify(khedCityCabServiceSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/88.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinkhedcity;